"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var _ = require('lodash');

var PropTypes = require('prop-types');

var React = require('react');

var template = require('./colorFormat.jsx');

var compose = require('../../hoc/compose');

var colorUtil = require('../../util/color');

var displayNames = require('../displayNames');

var isCloseOrEqual = function isCloseOrEqual(a, b) {
  return Math.abs(b - a) <= 3;
};

var ColorFormat = /*#__PURE__*/function (_React$Component) {
  _inherits(ColorFormat, _React$Component);

  var _super = _createSuper(ColorFormat);

  function ColorFormat(props) {
    var _this;

    _classCallCheck(this, ColorFormat);

    _this = _super.call(this, props);
    _this.state = {
      format: 'HEX',
      hsb: colorUtil.hexToHsb(_this.props.value)
    };
    _this.formats = [{
      value: 'HEX',
      label: 'HEX'
    }, {
      value: 'RGB',
      label: 'RGB'
    }, {
      value: 'HSB',
      label: 'HSB'
    }];

    _this.hexValidator = function (hex) {
      return /^[0-9a-f]{6}$/i.test(hex);
    };

    _this.getRGB = function () {
      return colorUtil.hexToRgb(_this.props.value);
    };

    _this.getHSB = function () {
      return colorUtil.hexToHsb(_this.props.value);
    };

    _this.onRGBChange = function (val, key) {
      return _(_this.props.value).thru(colorUtil.hexToRgb).assign(_defineProperty({}, key, val)).thru(colorUtil.rgbToHex).thru(_this.props.onChange).value();
    };

    var updateHsb = function updateHsb(hsb, key) {
      var hex = colorUtil.hsbToHex(hsb);

      _this.setState({
        hsb: hsb,
        lastChange: key
      }, function () {
        _this.props.onChange(hex);
      });
    };

    _this.onHSBChange = function (val, key) {
      return _(_this.state.hsb).assign(_defineProperty({}, key, val)).thru(function (hsb) {
        return updateHsb(hsb, key);
      }).value();
    };

    return _this;
  }

  _createClass(ColorFormat, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var _this2 = this;

      var lastChange = this.state.lastChange;
      var hsb = colorUtil.hexToHsb(nextProps.value);

      var shouldKeepHue = function shouldKeepHue() {
        return hsb.saturation < 5 || hsb.brightness < 5 || isCloseOrEqual(hsb.hue, _this2.state.hsb.hue);
      };

      var stateChange = lastChange ? {
        lastChange: null
      } : {
        hsb: _.defaults({
          hue: shouldKeepHue() ? this.state.hsb.hue : hsb.hue
        }, hsb)
      };
      this.setState(stateChange);
    }
  }, {
    key: "render",
    value: function render() {
      return template.call(this);
    }
  }]);

  return ColorFormat;
}(React.Component);

ColorFormat.displayName = displayNames.COLOR_FORMAT;
ColorFormat.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  invalidHexMessage: PropTypes.string
};
ColorFormat.defaultProps = {};
module.exports = compose(ColorFormat);